import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import posthog from 'posthog-js';
import { LocaleService } from './services/locale.service';
import { selectLoggedInUser } from './store/auth/auth.selectors';
import { FeatureFlagSelectors } from './store/feature-flags/feature-flags.selectors';
import { extractDomain } from './utils/utils';

@Component({
  selector: 'pm-root',
  template: '<router-outlet />',
  imports: [RouterOutlet],
  // TODO are these styles still used/needed?
  styles: `
    ::ng-deep .mdc-menu-surface.mat-mdc-select-panel {
      max-height: 478px !important;
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  `,
})
export class AppComponent {
  private readonly store = inject(Store);
  private readonly user = this.store.selectSignal(selectLoggedInUser);
  private readonly localeService = inject(LocaleService);

  posthogFeatureFlag = this.store.selectSignal(
    FeatureFlagSelectors.selectPosthogFeatureFlagEnabled,
  );

  constructor() {
    this.localeService.validateLocalStorageLocale();
    effect(() => {
      const posthogEnabled = this.posthogFeatureFlag().enabled;
      const currentUser = this.user();

      if (posthogEnabled && currentUser) {
        console.info('Initializing Analytics');
        posthog.init(environment.posthogKey, {
          api_host: environment.posthogHost,
          person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
          session_recording: {
            maskAllInputs: false,
            maskInputOptions: {
              password: true, // Highly recommended as a minimum!!
              text: false,
            },
          },
        });
        posthog.setPersonProperties({
          domain: extractDomain(currentUser?.email),
          company: currentUser?.company,
        });
      }
    });
  }
}
